import React, { useState, useEffect } from 'react';
import '../Styles/CardCarousel.css';
import ResourcesCard from './ResourcesCard';
import ItemsCarousel from 'react-items-carousel';
import arrow from '../../Assets/chevron-arrow.svg'

const CardCarousel = ({academicResources}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [numberOfCards, setNumberOfCards] = useState(2);

  useEffect(() => {
    // Update the number of cards based on the screen width
    const handleResize = () => {
      if (window.innerWidth <= 1000) {
        setNumberOfCards(1);
      } else {
        setNumberOfCards(2);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const carouselItems = academicResources.map((resource) => (
    <div key={resource.id}>
      <ResourcesCard {...resource}/>
    </div>
  ))

  return (
    <div className="academic-resources-container">
      <ItemsCarousel
        infiniteLoop
        outsideChevron
        gutter={12}
        showSlither={false}
        firstAndLastGutter={false}
        activePosition={'center'}
        numberOfCards={numberOfCards}
        activeItemIndex={activeItemIndex}
        requestToChangeActive={setActiveItemIndex}
        rightChevron={
          <img src={arrow}/>
        }
        leftChevron={
          <img src={arrow} style={{ transform: 'scaleX(-1)' }} />
        }
        chevronWidth={60}
        children={carouselItems}
      />
    </div>
  );
};

export default CardCarousel;
